import { render, staticRenderFns } from "./SectionBankData.vue?vue&type=template&id=b11bf35e&"
import script from "./SectionBankData.vue?vue&type=script&lang=js&"
export * from "./SectionBankData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports